"use client";

import { getStoryblokApi } from "@/lib/storyblok/config";

export interface StoryblokProviderProps {
  children: React.ReactNode | React.ReactNode[];
}

export default function StoryblokProvider({
  children,
}: StoryblokProviderProps) {
  getStoryblokApi();

  return children;
}
